@if (show) {
  <div class="print-notification-warning">
    <i class="fa fa-exclamation-triangle"></i>
    <span>{{ (singleOrderLine ? 'App_PrintLongerThisProductMessage' : 'App_PrintLongerOneOrMoreProductsMessage') | translate }}</span>
  </div>
}
